import { connect } from 'react-redux';
import { getUploadById } from '../../../../../redux/uploads/selectors';
const mapStateToProps = (state, { fileId })=>{
    return {
        fileUploadInfo: getUploadById(state, fileId)
    };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=UploadThumb.container.js.map